module.exports = __webpack_public_path__ + "static/media/hand-spock.8c59ac45.svg";